import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DictionaryModule, MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from 'src/tmc-common/widgets/terminal/centered-scrollable-content/centered-scrollable-content.module';
import { TapableTerminalCardModule } from 'src/tmc-common/widgets/terminal/tabbable-terminal-card/tapable-terminal-card.module';
import { DocumentScannerPreviewDialog } from './component/document-scanner-preview-dialog';
import { TransportRegistrationDocumentScanComponent } from './component/transport-registration-document-scan.component';



@NgModule({
  declarations: [
    TransportRegistrationDocumentScanComponent,
    DocumentScannerPreviewDialog
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    TapableTerminalCardModule,
    CenteredScrollableContentModule,
    CommonTranslationModule
  ]
})
export class TransportRegistrationDocumentScanModule { }
